import {DotMenu} from './dot_menu';

export default DotMenu;
